import { z } from 'zod';

export const editCustomerSchema = z.object({
    fullName: z.string().trim().min(1, 'Please enter a name'),
    email: z.string().trim().min(1, 'Please enter an email').email('Please enter a valid email'),
    phoneNumber: z.string().optional(),
});

export const createInvoiceSchema = z.object({
    description: z.string().trim().min(1, 'Please enter a description'),
    amount: z
        .string()
        .min(1, 'Please enter an amount')
        .refine(val => !Number.isNaN(Number(val)), 'Amount must be a valid number')
        .refine(val => {
            const num = Number(val);
            return num >= 0.5 && num <= 25000.0;
        }, 'Amount must be between $0.50 and $25,000.00'),
});

export type EditCustomerFormData = z.infer<typeof editCustomerSchema>;
export type CreateInvoiceFormData = z.infer<typeof createInvoiceSchema>;
